// @ts-nocheck
import React from "react";
import useAuth from '../../hooks/useAuth';
import { useTranslation } from "react-i18next";
import { Divider, List, Typography, Card, Flex, Carousel, ConfigProvider, Image } from 'antd';
import StoreList from "../../components/StoreList";
import GalleryVideoImg from "../../components/GalleryVideoImg";
import { Translate } from "../../services/translate";
import '../../styles/terms.css';

const TLSFechouConta = () => {

	window.scrollTo(0, 0);

	const { t, i18n: { changeLanguage, language } } = useTranslation();
	const { auth, habRoles } = useAuth();

	const hab_func = habRoles([]);

	const gallery_list = [
		{
			"link": "/img/apps/fechou_conta_01.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/fechou_conta_02.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/fechou_conta_03.jpeg",
			"video": false
		},
		{
			"link": "/img/apps/fechou_conta_04.jpeg",
			"video": false
		}
	];

	return (
		<div>
			<h2 className="title is-1">Fechou a conta</h2>
			<br />
			<hr />
			<br />
			<StoreList
				//chrome_store={"https://chromewebstore.google.com/detail/ggogoinhjigamdpkogcjgkmlgcknlflb/preview?hl=pt-BR&authuser=1&pli=1"} 
				google_play={"https://play.google.com/store/apps/details?id=com.tlsengenharia.fechouconta"}
				apple_store={"https://apps.apple.com/br/app/fechou-a-conta/id6759939796"}
				microsoft_store={""}
				download={""}
				hab_download={hab_func}
				user={auth?.user}
			/>
			<br />
			<div style={{ width: "100%" }}>
				<div style={{ maxWidth: 903, margin: "auto" }}>
					<GalleryVideoImg gallery_list={gallery_list} />
				</div>
			</div>
			<br />
			<br />
			<Flex wrap gap="middle" justify="center" align="center">
				<List
					style={{ maxWidth: 1200 }}
					size="large"
					header={<h2 className="title is-1">{t('visao_geral')}</h2>}
					bordered
					dataSource={[<></>]}
					renderItem={(item: any) => <List.Item>{
						language == "pt-BR" ?
							(
								<>
									<div className='term_just'>
										Cansado de confusão na hora de dividir a conta do bar?<br />
										O <strong>Fechou a Conta</strong> foi criado para deixar o controle de consumo simples, transparente e justo. Registre tudo o que cada pessoa consumiu, acompanhe pagamentos em tempo real e saiba exatamente quanto cada um ainda precisa pagar.
										<br />
										<br />
										Sem dor de cabeça. Sem discussão. Sem cálculo na calculadora do celular.
										<br />
										<br />
										<h3>Recursos:</h3><br />
										<ul>
											<li><strong>Controle Individual:</strong> Registre o consumo de cada pessoa separadamente.</li>
											<li><strong>Cálculo Automático:</strong> O app calcula quanto cada um deve pagar.</li>
											<li><strong>Acompanhamento de Pagamentos:</strong> Marque quem já pagou e quem ainda está devendo.</li>
											<li><strong>Transparência Total:</strong> Todos visualizam os valores de forma clara e organizada.</li>
										</ul>
										<br />
										Simplifique a divisão da conta com o Fechou a Conta. Instale agora e tenha mais praticidade e justiça na hora de fechar!
									</div>
								</>
							)
							:
							language == "es" ?
								(
									<div className='term_just'>
										¿Cansado de la confusión al dividir la cuenta del bar?<br />
										<strong>Fechou a Conta</strong> fue creado para hacer el control de consumo simple, transparente y justo. Registra lo que cada persona consumió, sigue los pagos en tiempo real y sabe exactamente cuánto debe pagar cada uno.
										<br />
										<br />
										Sin dolores de cabeza. Sin discusiones. Sin cálculos en la calculadora del móvil.
										<br />
										<br />
										<h3>Recursos:</h3><br />
										<ul>
											<li><strong>Control Individual:</strong> Registra el consumo de cada persona por separado.</li>
											<li><strong>Cálculo Automático:</strong> La app calcula cuánto debe pagar cada uno.</li>
											<li><strong>Seguimiento de Pagos:</strong> Marca quién ya pagó y quién aún debe.</li>
											<li><strong>Transparencia Total:</strong> Todos pueden ver los valores de forma clara y organizada.</li>
										</ul>
										<br />
										Simplifica la división de la cuenta con Fechou a Conta. ¡Instálalo ahora y disfruta de una experiencia más justa y práctica!
									</div>
								)
								:
								(
									<div className='term_just'>
										Tired of confusion when splitting the bar bill?<br />
										<strong>Fechou a Conta</strong> was created to make expense tracking simple, transparent, and fair. Record what each person consumed, track payments in real time, and know exactly how much everyone still needs to pay.
										<br />
										<br />
										No headaches. No arguments. No calculator needed.
										<br />
										<br />
										<h3>Features:</h3><br />
										<ul>
											<li><strong>Individual Tracking:</strong> Record each person's consumption separately.</li>
											<li><strong>Automatic Calculation:</strong> The app calculates how much each person owes.</li>
											<li><strong>Payment Tracking:</strong> Mark who has already paid and who still owes.</li>
											<li><strong>Full Transparency:</strong> Everyone can clearly see the amounts in an organized way.</li>
										</ul>
										<br />
										Simplify bill splitting with Fechou a Conta. Install now and enjoy a fairer and more practical way to close the bill!
									</div>
								)
					}
					</List.Item>}
				/>
			</Flex>
		</div>
	);
}


export default TLSFechouConta;